module.exports = __webpack_public_path__ + "static/media/il-question-plant.238f8fb8.svg";